import 'slick-carousel';

function slider($slides, dots, arrows) {
  var slidesToShowDesktop = $slides.data('items');
  var slidesToShowTablet = $slides.data('tablet');
  var slidesToShowMobile = $slides.data('mobile');

  if (dots == undefined) {
    dots = false;
  }

  if (arrows == undefined) {
    arrows = false;
  }

  if (slidesToShowDesktop == undefined || slidesToShowDesktop < 2) {
    slidesToShowDesktop = 2;
  }

  if (slidesToShowTablet == undefined || slidesToShowTablet < 2) {
    slidesToShowTablet = 2;
  }

  if (slidesToShowMobile == undefined || slidesToShowMobile < 2) {
    slidesToShowMobile = 2;
  }

  $slides.slick({
    dots: dots,
    arrows: arrows,
    slidesToShow: slidesToShowDesktop,
    slidesToScroll: 1,
    speed: 500,
    centerMode: false,
    variableWidth: false,
    adaptiveHeight: false,
    fade: false,
    autoplay: false,
    autoplaySpeed: 10000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: dots,
          slidesToShow: slidesToShowTablet
        }
      },
      {
        breakpoint: 768,
        settings: {
          dots: dots,
          slidesToShow: slidesToShowMobile
        }
      },
      {
        breakpoint: 480,
        settings: {
          dots: dots,
          slidesToShow: 1
        }
      }
    ]
  });
}

export default slider;
